<template>
  <view>
    <Index
      wx:if="{{show}}"
      pageConfig="{{pageConfig}}"
      info="{{info}}"
    />
    <block wx:if="{{__mpx_mode__ === 'wx'}}"><Loading wx:if="{{loading}}" /></block>
  </view>
</template>

<script>
import { createPage } from '@mpxjs/core'
import viewsMixin from '../../lib/mixin/views-v3'
import { props } from '../../editor/cz/model/props'
createPage({
  data: { props },
  mixins: [ viewsMixin() ],
})
</script>
<script name="json">
const config = {
  "navigationBarTitleText": "",
  "backgroundColor": "#ffffff",
  "usingComponents": {
    "Index": "../../editor/cz//index",
  },
}
if (__mpx_mode__ === 'wx') {
  config.usingComponents.Loading = '../../components/common/loading.mpx'
}
module.exports = config
</script>
<style lang="stylus" scoped>
</style>
